import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

import { type IBranding } from '@administration/shared/models/application-branding.interface';
import { IconComponent } from '@tess-core/shared';

@Component({
  selector: 'tess-navigation-top',
  imports: [IconComponent],
  templateUrl: './navigation-top.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationTopComponent {
  branding = input.required<IBranding>();
  closed = input(false);
  toggled = output<void>();

  actionClasses = computed(() => {
    let classes =
      'text-white h-9 opacity-70 justify-center w-8 z-30 cursor-pointer transition-all self-center -translate-x-full origin-center -ml-2 rounded-sm border-0 hover:opacity-100 bg-menu-bg-2';
    if (this.closed()) {
      classes += ' w-10 h-10 opacity-100 translate-x-0.5 rounded-tr-3xl rounded-br-3xl';
    }

    return classes;
  });
}
